module.exports = __webpack_public_path__ + "static/hunt3-37fb206a0b83b389971098a143dc8956.jpg";